module.exports = __webpack_public_path__ + "img/Weapon_292.42b3482f.png";